export default "__VITE_ASSET__DtZZ_PUW__"